import styles from './addToCartLabel.module.css';

interface AddToCartLabelProps {
  atMaxQuantity?: boolean;
  countInCart: number;
  hasMultipleWeights: boolean;
  isBeingAddedToCart: boolean;
}

export function AddToCartLabel({
  atMaxQuantity,
  countInCart,
  hasMultipleWeights,
  isBeingAddedToCart,
}: AddToCartLabelProps) {
  if (isBeingAddedToCart) return null;

  return (
    <>
      {atMaxQuantity && 'Limit reached'}
      {!atMaxQuantity && (hasMultipleWeights ? 'Select weight' : 'Add to bag')}

      {countInCart ? (
        <div className={styles['count']}>{countInCart}</div>
      ) : null}
    </>
  );
}
